
import { DictionaryItemContent } from "../../components/dictionary";


export default function DictionaryItem () {

  return (
    <>
      <DictionaryItemContent/>
    </>
  )

}